import { render, staticRenderFns } from "./ReportForSim.vue?vue&type=template&id=358dcba1"
import script from "./ReportForSim.vue?vue&type=script&lang=js"
export * from "./ReportForSim.vue?vue&type=script&lang=js"
import style0 from "./ReportForSim.vue?vue&type=style&index=0&id=358dcba1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports